import * as styles from "./blog-post.module.css";
import { differenceInDays, formatDistance, format } from "date-fns";
import AuthorList from "./author-list";
import Container from "./container";
import PortableText from "./portableText";
import React from "react";
import { buildImageObj } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Helmet from "react-helmet";

function BlogPost(props) {
  const {
    _rawBody,
    authors,
    title,
    mainImage,
    publishedAt,
    advertisement,
    chatBot,
  } = props;
  let topPosition = "";
  let textAlighn = "";
  let zIndex = 0;
  let positionType = "";
  if (advertisement) {
    if (advertisement.position == "belowHeader") {
      topPosition = "80px";
      zIndex = 0;
      positionType = "absolute";
    } else {
      topPosition = "0px";
      zIndex = "9999";
      positionType = "fixed";
    }
    if (advertisement.align == "left") {
      textAlighn = "0%";
    } else {
      textAlighn = "35%";
    }
  }
  return (
    <Box>
      {chatBot ? (
        <Helmet>
          <script
            src="//code.tidio.co/4p5cdumnkc2qkb14ypvgfi3mvdzebpnd.js"
            async
          ></script>
        </Helmet>
      ) : null}
      {advertisement && advertisement.text ? (
        <Box
          pl={{ xs: 2, sm: 5, md: 20, lg: 38 }}
          pr={{ xs: 2, sm: 5, md: 20, lg: 38 }}
          style={{
            position: positionType,
            zIndex: zIndex,
            top: topPosition,
            left: textAlighn,
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <p
                style={{
                  margin: 0,
                  fontSize: "15px",
                }}
              >
                {advertisement.text}
              </p>
            </Grid>
          </Grid>
        </Box>
      ) : null}
      <Box
        pl={{ xs: 2, sm: 5, md: 20, lg: 38 }}
        pr={{ xs: 2, sm: 5, md: 20, lg: 38 }}
        mt={{ xs: 13, sm: 13, md: 13 }}
        mb={2}
      >
        <Grid container>
          <Grid item xs={12}>
            <h1 className={styles.blogPostTitle}>{title}</h1>
          </Grid>
        </Grid>
        {mainImage && mainImage.asset && (
          <Grid container>
            <Grid item xs={12}>
              <img
                src={imageUrlFor(buildImageObj(mainImage))
                  .width(1200)
                  .height(Math.floor((9 / 16) * 1200))
                  .fit("crop")
                  .auto("format")
                  .url()}
                className={styles.blogPostMainImg}
                alt={mainImage.alt}
              />
            </Grid>
          </Grid>
        )}
        <Grid container>
          <Grid item xs={12}>
            {_rawBody && <PortableText blocks={_rawBody} />}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default BlogPost;
